import React from "react"
import classNames from "classnames"
import "./page.css"

export const Page = ({ children, className, ...props }) => (
  <div className={classNames("core-page", className)} {...props}>
    {children}
  </div>
)

export const PageHeader = ({ children, className, ...props }) => (
  <div className={classNames("core-page-header", className)} {...props}>
    {children}
  </div>
)

export const PageBody = ({ children, className, ...props }) => (
  <div className={classNames("core-page-body", className)} {...props}>
    {children}
  </div>
)

export const PageContent = ({ children, className, ...props }) => (
  <div className={classNames("core-page-content", className)} {...props}>
    {children}
  </div>
)

export const PageSidebar = ({ children, className, ...props }) => (
  <div className={classNames("core-page-sidebar", className)} {...props}>
    {children}
  </div>
)

export const PageFooter = ({ children, className, ...props }) => (
  <div className={classNames("core-page-footer", className)} {...props}>
    {children}
  </div>
)
